import { useState, useEffect } from "react"
import { useQuery } from "@apollo/client"
import cx from "classnames"
import GET_USER_ORDERS from "../../graphql/queries/GetUserOrders"
import Modal from "../../shared/components/Modal"
import SelectBlanketOrderModal from "../../shared/components/SelectBlanketOrderModal"
import SongActionsTooltip from "./SongActionsTooltip"

import StarIcon from "../../icons/StarIcon"
import FlashlightIcon from "../../icons/FlashlightIcon"
import DownloadIcon from "../../icons/DownloadIcon"
import BookIcon from "../../icons/BookIcon"
import CassetteIcon from "../../icons/CassetteIcon"
import CustomizeIcon from "../../icons/CustomizeIcon"
import PlayLargeIcon from "../../icons/PlayLargeIcon"
import PlusIcon from "../../icons/PlusIcon"
import { LuFileSpreadsheet } from "react-icons/lu";
import { IconContext } from "react-icons";

import { internalRoles } from "../../shared/utils/helpers"
import {
  addToCart,
  addToProjectSearch,
  customizeSongRequest,
  addToMixtape,
  handleCustomLicenseRequest,
} from "../../shared/utils/modalHelper"
import { favoriteUnfavoriteSongVersion } from "../../shared/utils/backbone/songVersionActions"
import { setExclusivityMessage } from "../../shared/utils/browse"
import { openLogin, openLyricsModal, openProInformationModal } from "../../../../../javascript/services/modal"

const SongVersionPageActions = () => {
  const el = document.getElementById("mm-song-version-actions")
  const user_role = document.body.getAttribute('data-user-role')
  const songVersionData = el && el.getAttribute("data-song-version")

  const [songVersion, setSongVersion] = useState({})
  const svPlaySerializer = songVersion.play_serializer
  const isExclusive = songVersion.song?.exclusive
  const shouldShowTooltip =
    !songVersion.is_pre_release && (isExclusive || songVersion.is_vintage)

  const isInternal = internalRoles.includes(user_role)
  const exclusivityMessage = setExclusivityMessage(songVersion.is_vintage, isExclusive)
  const availableForClick = songVersion.is_available_for_click
  const { loading, error, data } = useQuery(GET_USER_ORDERS)
  const [openModal, setOpenModal] = useState(false)
  const [currentTooltip, setCurrentTooltip] = useState("")

  const [expandedDownloads, setExpandedDownloads] = useState(false)
  const [isFavorited, setIsFavorited] = useState(false)

  let currentUserOrders = []
  let openBlanketOrder = false
  let openOrders = {}

  if (!loading) {
    if (!data) {
      console.error("error", error)
    } else {
      currentUserOrders = data?.account?.orders
      currentUserOrders.map((deal) => {
        if (deal.allowClientToSelectTbd) {
          deal.lineItems.map((item) => {
            if (item.songVersionTitle === "TBD") {
              openBlanketOrder = true
              !openOrders[deal.projectName]
                ? (openOrders[deal.projectName] = [item.id])
                : openOrders[deal.projectName].push(item.id)
            }
          })
        }
      })
    }
  }
  const handleTooltip = (name) => ({
    onMouseEnter: () => setCurrentTooltip(name),
    onMouseLeave: () => setCurrentTooltip(""),
  })
  

  const handlePlaySong = () => {
    const songVersionDetail = { detail: JSON.parse(svPlaySerializer) }
    // Fire a play-song event handled by the audio_player_controller.js
    const playEvent = new CustomEvent("play-song", songVersionDetail)
    document.dispatchEvent(playEvent)
  }

  const handleOpenModal = () => {
    if (!openModal) {
      setOpenModal(true)
    }
  }

  const toggleExpandDownloads = () => {
    setExpandedDownloads(!expandedDownloads)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleLicenseClick = () => {
    const songVersionData = JSON.parse(svPlaySerializer)
    // put the song version in session storage regardless of if it's click or custom only
    sessionStorage.setItem("customRequestData", svPlaySerializer)
    if (availableForClick) {
      addToCart(songVersionData)
    } else {
      // mm.router.navigate("/licensing/custom-request", { trigger: true })
      handleCustomLicenseRequest(songVersionData)
    }
  }
  const handleProButtonClick = (id) => {
    openProInformationModal(id)
  }

  const handleFavoriteUnfavorite = async () => {
    const request = isFavorited ? "remove" : "add"
    setIsFavorited(!isFavorited)
    const res = await favoriteUnfavoriteSongVersion(songVersion.id, request)
    if (!res.ok) {
      setIsFavorited(request == "remove" ? true : false)
      return
    }
  }

  const handleLyricsPopUp = () => {
    openLyricsModal(songVersion)
  }

  const handleOnClick = (e) => {
    if (
      // if not clicked in song download options menu
      !e.target.closest(["div.download-options-menu", ".download"])
    ) {
      setExpandedDownloads(false)
    }
  }

  useEffect(() => {
    document.body.addEventListener("click", handleOnClick)
    return () => {
      document.body.removeEventListener("click", handleOnClick)
    }
  }, [])

  useEffect(() => {
    if (songVersionData) {
      const parsed = JSON.parse(songVersionData)
      setSongVersion(parsed)
      setIsFavorited(mm.user.favoriteSongVersions?.hasOwnProperty(parsed.id))
    }
  }, [songVersionData])

  return (
    <>
      <div className="actions">
        <div className="song-version-license">
          <button
            className={cx("action license", !availableForClick && "custom-only")}
            data-action="license"
            data-cy={availableForClick ? "buy-license" : "custom-license"}
            onClick={handleLicenseClick}
            {...handleTooltip("license")}
          >
            <span className="button-text">
              {availableForClick ? "License" : "Custom License"}
            </span>

            {shouldShowTooltip && (
            <SongActionsTooltip
              tooltipType="license-tooltip"
              vintage={songVersion.vintage}
              exclusive={songVersion.exclusive}
              action="license"
              cy="license-partial-exclusivity-tooltip"
              exclusivityMessage={exclusivityMessage}
              show={currentTooltip === "license"}
            />
          )}
          </button>

          {(isInternal && isExclusive) && (
            <button className="license warning">
              <span className="button-text">Warning! Exclusivity!</span>
            </button>
          )}
          
          <div className="mobile-actions">
            <button className="action play" onClick={handlePlaySong}>
              <PlayLargeIcon />
            </button>
            <button
              className={cx("action favorite", isFavorited && "selected favorited")}
              onClick={user_role === "guest" ? openLogin : handleFavoriteUnfavorite}
            >
              <StarIcon favorited={isFavorited} />
            </button>

          </div>
        </div>

        <ol>
          <li
            className="action play mm-hover-connect"
            data-action="play"
            data-connect="song-version-actions"
            data-connect-text="Play"
            onClick={() => handlePlaySong()}
          >
            <span className="icon">
              <PlayLargeIcon />
            </span>
            <span className="label">Play Track</span>

          </li>
          <li
            className={cx("action mixtape", user_role === "guest" && "disabled")}
            data-action={user_role === "guest" ? "login" : "mixtape"}
            onClick={(e) => (user_role === "guest" ? openLogin(e) : addToMixtape(songVersion.id))}
          >
            <a data-prevent-default>
              <span data-cy="add-to-mixtape" className="icon">
                <CassetteIcon />
              </span>
              <span className="label">Add To Playlist</span>
            </a>
          </li>
          <li
            className={cx("action favorite", user_role === "guest" && "disabled")}
            data-action={user_role === "guest" ? "login" : "favorite"}
            onClick={(e) => (user_role !== "guest" ? handleFavoriteUnfavorite() : openLogin(e))}
          >
            <a data-prevent-default>
              <span
                data-cy="add-to-favorites"
                className={cx("icon", isFavorited ? "selected" : "")}
              >
                <span className={cx("favorite-icon", isFavorited ? "favorited selected" : "")}>
                  <StarIcon favorited={isFavorited} />
                </span>
              </span>
              <span className="label">{isFavorited ? "Remove Favorite" : "Add To Favorites"}</span>
            </a>
          </li>
     
          {/** Current user has open blanket deal */}
          {openBlanketOrder && (
            <li
              className="action blanket-deal"
              data-action="blanket-deal"
              onClick={handleOpenModal}
            >
              <a data-prevent-default>
                <span data-cy="add-to-blanket-deal" className="icon">
                  <PlusIcon />
                </span>
                <span className="label">Add to Blanket Deal</span>
              </a>
              {openModal && (
                <Modal>
                  <SelectBlanketOrderModal
                    handleCloseModal={handleCloseModal}
                    artist={songVersion.artist}
                    sv={songVersion}
                    svid={songVersion.id}
                    currentUserOrders={currentUserOrders}
                    openOrders={openOrders}
                  />
                </Modal>
              )}
            </li>
          )}
       
          {songVersion.lyrics && (
            <li className="action lyrics" data-action="lyrics">
              <a data-prevent-default onClick={handleLyricsPopUp}>
                <span className="icon">
                  <BookIcon />
                </span>
                <span className="label">Lyrics</span>
              </a>
            </li>
          )}

          {/* Clicking this opens download options menu */}
          <li
            className={cx("action download", user_role === "guest" && "disabled")}
            data-action={user_role === "guest" ? "login" : "download"}
            data-cy={cx("download", user_role === "guest" && "disabled")}
          >
            {/* ONLY include if logged in */}
            {user_role !== "guest" ? (
              <>
                <a id="downloadLink" onClick={toggleExpandDownloads}  {...handleTooltip("download")}>
                  <span className="icon">
                    <DownloadIcon />
                  </span>
                  <span className="label">Download Song</span>
                </a>
                {/* Dropdown */}
                <ul className={cx("download-options-menu", expandedDownloads && "expanded")}>
                  <li className="download dropdown-item">
                    <a href={`/song_versions/${songVersion.id}/download/low`} target="_blank">
                      <span className="icon"><DownloadIcon /></span>
                      <span className="label">Low Res (MP3)</span>
                    </a>
                  </li>
                  <li className="download dropdown-item">
                    <a href={`/song_versions/${songVersion.id}/download/high`} target="_blank">
                      <span className="icon"><DownloadIcon /></span>
                      <span className="label">Hi Res (WAV/AIFF)</span>
                    </a>
                  </li>
                  <li className={cx("download dropdown-item", !songVersion.has_stems && "disabled")}>
                    <a href={`/song_versions/${songVersion.id}/download_stems`} target="_blank">
                      <span className="icon"><DownloadIcon /></span>
                      <span className="label">Download Stems</span>
                    </a>
                  </li>
                </ul>
              </>
            ) : (
              <a id="guest-download" onClick={openLogin} {...handleTooltip("Login")}>
                <span className="icon"><DownloadIcon /></span>
                <span className="label">Download Song</span>
              </a>
            )}
          </li>

          <li className="action customize" data-action="customize">
            <a data-prevent-default onClick={() => customizeSongRequest(songVersion.id)}>
              <span className="icon">
                <CustomizeIcon />
              </span>
              <span className="label">Customize</span>
            </a>
          </li>


          {isInternal && (
            <>
              <li className="action cuesheet" data-action="cuesheet">
                <a data-prevent-default onClick={() => handleProButtonClick(songVersion.id)}>
                  <IconContext.Provider value={{ style: { strokeWidth: 1, height: "25px", width: "25px" } }}>
                    <span className="icon">
                      <LuFileSpreadsheet />
                    </span>
                  </IconContext.Provider>
                  <span className="label">Cue Sheet Info</span>
                </a>
              </li>
              <li
                className="action project-search"
                data-action="projectSearch"
                data-cy="add-to-search"
                onClick={() => addToProjectSearch(songVersion.id, songVersion.song_id)}
                {...handleTooltip("projectSearch")}
              >
                <a data-prevent-default>
                  <span className="icon">
                    <FlashlightIcon />
                  </span>
                  <span className="label">Add to Search</span>
                </a>
              </li>
            </>
          )}

          {/**if song is exclusive, tooltip is visible for project-search button */}
          {/** else display share button */}

          {shouldShowTooltip && (
            <SongActionsTooltip
              tooltipType="download-tooltip"
              vintage={songVersion.vintage}
              exclusive={songVersion.exclusive}
              action="download"
              cy="download-partial-exclusivity-tooltip"
              exclusivityMessage={exclusivityMessage}
              show={currentTooltip == "download"}
              additionalClass={songVersion.lyrics && "nudge"}
            />
          )}
          {shouldShowTooltip && (
            <SongActionsTooltip
              tooltipType="project-search-tooltip"
              vintage={songVersion.vintage}
              exclusive={songVersion.exclusive}
              action="project-search"
              cy="search-partial-exclusivity-tooltip"
              exclusivityMessage={exclusivityMessage}
              show={currentTooltip == "projectSearch"}
              additionalClass={songVersion.lyrics && "de-nudge"}
            />
          )}
        </ol>
      </div>
    </>
  )
}

export default SongVersionPageActions
